import './sentry';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from '@app/App';
import { store } from '@app/store';
import ErrorBoundaryFallback from '@shared/components/others/ErrorBoundary/ErrorBoundaryFallback';
import './index.css';

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        <Sentry.ErrorBoundary fallback={<ErrorBoundaryFallback style={{ position: 'fixed' }} />}>
            <App />
        </Sentry.ErrorBoundary>
    </Provider>,
);
